import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { FieldBase } from '@app/modules/forms/abstracts/field-base'
import { CustomFormsModule } from '@app/modules/forms/forms.module'
import { UIModule } from '@app/modules/ui/ui.module'

@Component({
  selector: 'sb-field-boost',
  templateUrl: './field-boost.component.html',
  styleUrl: './field-boost.component.scss',
  imports: [CommonModule, FormsModule, CustomFormsModule, UIModule],
})
export class FieldBoostComponent extends FieldBase<boolean> {
  readonly wrapped = input<boolean>(false)

  protected checked = false

  writeValue(value: boolean): void {
    this.checked = value
  }

  onValueChange(value: boolean): void {
    this.checked = value
    this.onTouched()
    this.onChange(value)
  }
}
